import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["container", "template", "destroyField"]
  static values = { wrapperSelector: String }

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.innerHTML.replace(/NEW_RECORD/g, new Date().getTime())
    this.containerTarget.insertAdjacentHTML("beforeend", content)
  }

  remove(event) {
    event.preventDefault()
    const wrapper = event.target.closest(this.wrapperSelectorValue)
    if (!wrapper) return

    const destroyField = wrapper.querySelector("[data-nested-form-target='destroyField']")
    if (destroyField && wrapper.querySelector("input[name*='[id]']")) {
      destroyField.value = true
      wrapper.style.display = "none"
    } else {
      wrapper.remove()
    }
  }
}
